export const environment = {
    production: false,
    apiUrl: 'https://uat.api.audit-gate.process-gate-systems.com',
    keycloak: {
        url: 'https://uat.auth.process-gate-systems.com',
        realm: 'process-gate-systems-uat',
        clientId: 'audit-gate-uat',
    },
};
